import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await register(email, password, name); navigate("/"); }
    catch (e2) { setError(formatApiErrorDetail(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6"><div className="bg-teal-500/20 text-teal-500 p-2 rounded-full"><CheckCircle2 size={20} /></div><span className="font-display font-bold">Onboarding Follow-Up</span></div>
        <form onSubmit={submit} className="bg-white p-6 rounded-xl border border-slate-200 space-y-4">
          <h2 className="font-display text-lg font-bold text-slate-900">Crear cuenta</h2>
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre completo"
            className="w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.cl"
            className="w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña"
            className="w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button data-testid="register-submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 size={16} className="animate-spin" />} Registrarme
          </button>
          <Link to="/login" className="text-slate-500 text-sm">Ya tengo cuenta</Link>
        </form>
      </div>
    </div>
  );
}
